import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ActiveUserService } from '../services/activeuser.service';
import { map } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const activeUser = inject(ActiveUserService);

  if (activeUser.LoggedIn())
    return true;

  return activeUser.loggedInChanged.pipe(
    map((loggedIn) => {
      if (!loggedIn) {
        router.navigate(['/not-logged-in']);
        return false;
      }
      return true;
    })
  );
};
